import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminDetail, AdminUiState, GridMode, GridShow, NavItemRef } from 'Interfaces/Admin';

const INITIAL_STATE: AdminUiState = {
  view: 'grid',
  detail: null,
  path: [],
  selected: null,
  gridMode: 'users',
  gridShow: 'all',
  gridSelection: [],
};

const adminUiSlice = createSlice({
  name: 'adminUi',
  initialState: INITIAL_STATE,
  reducers: {
    /**
     *  Opens the column stack at the given path. The last entry is the selected
     *  item; the preceding ones are its ancestors, one column each.
     */
    showColumns(state, action: PayloadAction<{ path: NavItemRef[] }>) {
      state.view = 'columns';
      state.detail = null;
      state.path = action.payload.path;
      state.selected = action.payload.path[action.payload.path.length - 1] || null;
    },
    /** Opens a form or report in the detail pane, leaving the path intact. */
    showDetail(state, action: PayloadAction<AdminDetail>) {
      state.view = 'detail';
      state.detail = action.payload;
    },
    showGrid(state, action: PayloadAction<{ mode: GridMode; show: GridShow }>) {
      state.view = 'grid';
      state.detail = null;
      state.gridMode = action.payload.mode;
      state.gridShow = action.payload.show;
      state.gridSelection = [];
    },
    setGridShow(state, action: PayloadAction<GridShow>) {
      state.gridShow = action.payload;
      state.gridSelection = [];
    },
    setGridSelection(state, action: PayloadAction<number[]>) {
      state.gridSelection = action.payload;
    },
    clearSelection(state) {
      state.path = [];
      state.selected = null;
    },
  },
});

export const {
  showColumns, showDetail, showGrid, setGridShow, setGridSelection, clearSelection,
} = adminUiSlice.actions;

export default adminUiSlice.reducer;
